import React, { useContext, useEffect, useState } from 'react'
import {
	BrandsContainer,
	Container,
	Description,
	DescriptionContainer,
	Title,
} from './FormFinish.styles'
import { ReactComponent as SuccessWelbe } from 'App/assets/success-welbe.svg'
import { Button } from '@welbe/web-design-system'
import { GlobalContext } from 'contexts/Global'
import { ReactComponent as WelbeLogo } from 'App/assets/welbe-slogan.svg'
import { Loading } from 'App/components/Loading/Loading'
import { getParams } from 'utils/helpers'
import { sendMessage } from 'services/messenger'

export const FormFinish = () => {
	const userAgent = window.navigator.userAgent.toLowerCase()
	const isMobile = userAgent === 'welbe-webview'

	const [hasNext, setNext] = useState<boolean>(false)
	const [itemIndex, setItemIndex] = useState<string>('')
	const [formName, setFormName] = useState<string>('')
	const { isGlobalLoading, companySurvey, setGlobalLoading } =
		useContext<any>(GlobalContext)
	const { campaignAnswerSessions, campaign } = companySurvey

	const getFormType = async () => {
		const { id } = await getParams()
		const itemPosition = companySurvey.campaignAnswerSessions
			?.map((answerSession: any) => answerSession.id)
			?.indexOf(id)

		const isLastForm =
			itemPosition + 1 === companySurvey.campaignAnswerSessions?.length

		setFormName(campaignAnswerSessions[itemPosition].questionnaire.name)
		setItemIndex(itemPosition)
		setNext(!isLastForm)
	}

	const handleNext = async () => {
		const { origin, pathname } = window.location
		const queryParams = new URLSearchParams(window.location.search)
		queryParams.set('id', `${campaignAnswerSessions[itemIndex + 1].id}`)

		window.location.href = `${origin}${pathname}?${queryParams.toString()}`
	}

	const fetchSurvey = async () => {
		try {
			setGlobalLoading(true)
			await getFormType()
		} catch (error) {
			console.error(error)
		} finally {
			setGlobalLoading(false)
		}
	}

	useEffect(() => {
		fetchSurvey()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (isGlobalLoading) return <Loading />

	return (
		<Container>
			<Title>Campaña NOM-035</Title>
			<SuccessWelbe />
			{!hasNext ? (
				<div>
					<Description variant>
						¡{campaign.company.fancyName} te agradece por participar en las
						evaluaciones!
					</Description>
					<Description>
						Analizaremos los resultados generales para llevar a cabo planes de
						acción y mejoras en tu entorno laboral.
					</Description>
					<BrandsContainer>
						<img
							width="200px"
							src={campaign.company.logoUrl}
							alt={`${campaign.company.fancyName}-logo`}
						/>

						<Description>TE CUIDA CON</Description>
						<WelbeLogo />
						{isMobile && (
							<Button
								width="260px"
								onClick={() =>
									sendMessage({
										status: 'completed',
										data: { message: 'completed' },
									})
								}
							>
								Cerrar
							</Button>
						)}
					</BrandsContainer>
				</div>
			) : (
				<DescriptionContainer>
					<Description>
						¡Gracias por terminar el cuestionario sobre {formName}!
					</Description>
					<Button width="260px" onClick={handleNext}>
						Siguiente cuestionario
					</Button>
				</DescriptionContainer>
			)}
		</Container>
	)
}
